import styled from "@emotion/styled";
import { ThemeProp } from "../../../styles/theme";

export interface NetworkButtonStyledProps extends ThemeProp {
  isDropdownOpen: boolean;
}
export const NetworkButtonStyled = styled.button<NetworkButtonStyledProps>(
  ({ theme, isDropdownOpen }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: 0,
    background: isDropdownOpen ? theme.theme[700] : "none",
    height: "36px",
    color: theme.font.primary.default,
    fontFamily: theme.fontFamilies.Primary,
    fontWeight: theme.fontWeights["work-sans-0"],
    borderRadius: "14px",
    gap: "4px",
    ":hover": {
      background: theme.theme[700],
    },
    lineHeight: theme.lineHeights["3"],
    fontSize: theme.fontSize[6],
    padding: "8px",
  })
);
